import { faCube, faPlus } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Skeleton } from '@sixui/ui';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';

import { Heading } from '~/components/molecules/Heading';
import { parseOrganizationUserRoles } from '~/helpers/parseOrganizationUserRoles';
import { useOrganizationUserQuery } from '~/lib/api/modules/Organizations/hooks/useOrganizationUserQuery';
import { OrganizationAppGrid } from '../molecules/OrganizationAppGrid';

export type IOrganizationAppsPageProps = {
  organizationId: string;
};

export const OrganizationAppsPage: React.FC<IOrganizationAppsPageProps> = (
  props,
) => {
  const { organizationId } = props;
  const { t } = useTranslation();
  const organizationUserQuery = useOrganizationUserQuery({ organizationId });
  const organizationUserRoles = organizationUserQuery.data?.roles
    ? parseOrganizationUserRoles(organizationUserQuery.data?.roles)
    : undefined;
  const canCreate = organizationUserRoles?.atLeastAdmin;

  return (
    <>
      <Helmet>
        <title>{t('OrganizationAppsPage.seo.title')}</title>
      </Helmet>

      <Heading
        icon={<FontAwesomeIcon icon={faCube} />}
        title={t('OrganizationAppsPage.title')}
        subtitle={t('OrganizationAppsPage.subtitle')}
        actions={
          organizationUserQuery.isLoading || canCreate ? (
            <Skeleton loaded={!organizationUserQuery.isLoading}>
              <Button
                href={`/organizations/${organizationId}/apps/create`}
                icon={<FontAwesomeIcon icon={faPlus} />}
              >
                {t('OrganizationAppsPage.create')}
              </Button>
            </Skeleton>
          ) : undefined
        }
      />

      <OrganizationAppGrid organizationId={organizationId} />
    </>
  );
};
